import {
    Alert,
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
} from '@mui/material';
import AutocompleteField from '../../components/general/fields/autocompleteField';
import FieldText from '../../components/general/fields/fieldText';
import { FormikProps } from 'formik';
import { valuesChat } from './formikData';
import { IDocumentType } from '../../../shared/types/document-type';
import { ISelectType } from '../../../shared/types/select-type';
import FieldTextAreaAutoSize from '../../components/general/fields/fieldTextAreaAutoSize';
import DropZoneField from '../../components/general/fields/dropzoneField';
import { PrivacyDialog } from './privacyDialog';

interface Props {
    formik: FormikProps<typeof valuesChat>;
    identifications: IDocumentType[];
    countries: ISelectType[];
    departments: ISelectType[];
    cities: ISelectType[];
    requestTypes: ISelectType[];
    requestClassifications: ISelectType[];
    onChangeFiles: (value: any[]) => void;
    load?: boolean;
    disabledBtn?: boolean;
    onChangeShowPrivacy: (show: boolean) => void;
    showPrivacy?: boolean;
    isAnonymous?: boolean;
}

export const Form = ({
    formik,
    identifications,
    countries,
    departments,
    cities,
    requestTypes,
    requestClassifications,
    onChangeFiles,
    load,
    disabledBtn,
    onChangeShowPrivacy,
    showPrivacy,
    isAnonymous,
}: Props) => {
    return (
        <>
            {!isAnonymous && (
                <Grid container spacing={2} mt="1rem">
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Tipo de documento{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <AutocompleteField
                            data={identifications}
                            size="small"
                            name="documentType"
                            touched={formik.touched.documentType}
                            errors={formik.errors.documentType}
                            value={formik.values.documentType}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('documentType', value)
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Número documento identificación{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <FieldText
                            name="document"
                            size="small"
                            touched={formik.touched.document}
                            errors={formik.errors.document}
                            value={formik.values.document}
                            onChange={(event) => {
                                const { value } = event.target;
                                if (
                                    (/^[A-Za-z\d]*$/.test(value) ||
                                        value.includes('-')) &&
                                    value.length <= 15
                                ) {
                                    formik.handleChange(event);
                                }
                            }}
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Nombres y apellidos y/o razon Social{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <FieldText
                            name="fullName"
                            size="small"
                            touched={formik.touched.fullName}
                            errors={formik.errors.fullName}
                            value={formik.values.fullName}
                            onChange={(event) => {
                                const { value } = event.target;
                                if (/^[A-Za-z ]*$/.test(value)) {
                                    formik.handleChange(event);
                                }
                            }}
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Dirección{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <FieldText
                            name="address"
                            size="small"
                            touched={formik.touched.address}
                            errors={formik.errors.address}
                            value={formik.values.address}
                            onChange={(event) => {
                                formik.handleChange(event);
                            }}
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Teléfono depositante{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <FieldText
                            name="phone"
                            size="small"
                            touched={formik.touched.phone}
                            errors={formik.errors.phone}
                            value={formik.values.phone}
                            onChange={(event) => {
                                const { value } = event.target;
                                if (
                                    /^\d*$/.test(value) ||
                                    value.includes('-')
                                ) {
                                    formik.handleChange(event);
                                }
                            }}
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                País de residencia{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <AutocompleteField
                            data={countries}
                            size="small"
                            name="country"
                            touched={formik.touched.country}
                            errors={formik.errors.country}
                            value={formik.values.country}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('country', value)
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Departamento{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <AutocompleteField
                            data={departments}
                            size="small"
                            name="department"
                            touched={formik.touched.department}
                            errors={formik.errors.department}
                            value={formik.values.department}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('department', value)
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={1}>
                            <label className="cancilleria-label">
                                Ciudad{' '}
                                <b className="cancilleria-label-required">*</b>:
                            </label>
                        </Box>
                        <AutocompleteField
                            data={cities}
                            size="small"
                            name="city"
                            touched={formik.touched.city}
                            errors={formik.errors.city}
                            value={formik.values.city}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('city', value)
                            }
                            onBlur={formik.handleBlur}
                        />
                    </Grid>
                </Grid>
            )}

            <Grid container spacing={2} mt="10px">
                <Grid item xs={12} md={6}>
                    <Box mb={1}>
                        <label className="cancilleria-label">
                            Correo electrónico{' '}
                            <b className="cancilleria-label-required">*</b>:
                        </label>
                    </Box>
                    <FieldText
                        name="email"
                        size="small"
                        touched={formik.touched.email}
                        errors={formik.errors.email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box mb={1}>
                        <label className="cancilleria-label">
                            Confirmación correo electrónico{' '}
                            <b className="cancilleria-label-required">*</b>:
                        </label>
                    </Box>
                    <FieldText
                        name="emailComfirmation"
                        size="small"
                        touched={formik.touched.emailComfirmation}
                        errors={formik.errors.emailComfirmation}
                        value={formik.values.emailComfirmation}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
            </Grid>

            <Grid>
                <Typography fontSize="1.5rem" mt="1rem">
                    Datos solicitante
                </Typography>
            </Grid>
            <Grid container spacing={2} mt="1rem" mb={20}>
                <Grid item xs={12} md={6}>
                    <Box mb={1}>
                        <label className="cancilleria-label">
                            Tipo Solicitud{' '}
                            <b className="cancilleria-label-required">*</b>:
                        </label>
                    </Box>
                    <AutocompleteField
                        data={requestTypes}
                        size="small"
                        name="requestType"
                        touched={formik.touched.requestType}
                        errors={formik.errors.requestType}
                        value={formik.values.requestType}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('requestType', value)
                        }
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box mb={1}>
                        <label className="cancilleria-label">
                            Clasificación solicitud{' '}
                            <b className="cancilleria-label-required">*</b>:
                        </label>
                    </Box>
                    <AutocompleteField
                        data={requestClassifications}
                        size="small"
                        name="requestClassification"
                        touched={formik.touched.requestClassification}
                        errors={formik.errors.requestClassification}
                        value={formik.values.requestClassification}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('requestClassification', value)
                        }
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                <Grid item xs={12} width="100%">
                    <Alert severity="info">
                        Por favor detalle al máximo posible la información sobre
                        su solicitud e identifique si es persona natural,
                        persona jurídica, niño, niña, adolescente o apoderado y,
                        medio al cual quiere recibir respuesta.
                    </Alert>
                </Grid>
                <Grid item xs={12} width="100%">
                    <Box mb={1} width="100%">
                        <label className="cancilleria-label">
                            Descripción{' '}
                            <b className="cancilleria-label-required">*</b>:
                        </label>
                    </Box>
                    <FieldTextAreaAutoSize
                        name="description"
                        touched={formik.touched.description}
                        errors={formik.errors.description}
                        value={formik.values.description}
                        onChange={(event) => {
                            formik.handleChange(event);
                        }}
                        onBlur={formik.handleBlur}
                    />
                </Grid>
                {!load && (
                    <Grid item xs={12}>
                        <DropZoneField
                            name="files"
                            onChange={onChangeFiles}
                            accept={'application/pdf'}
                            errors={formik.errors.filesSize}
                        />
                    </Grid>
                )}
                <Grid item xs={12} display="flex" justifyContent="center">
                    <FormControlLabel
                        control={
                            <Checkbox
                                className="checkbox_boot"
                                id="policy"
                                name="aceptoPolitica"
                                checked={formik.values.acceptPolicy}
                                onChange={() => onChangeShowPrivacy(true)}
                                onBlur={formik.handleBlur}
                            />
                        }
                        label={
                            <a onClick={() => onChangeShowPrivacy(true)}>
                                Consiento que mis datos personales sean
                                transferidos en los términos que señala el
                                presente aviso de privacidad.
                            </a>
                        }
                    />
                    <PrivacyDialog
                        open={showPrivacy}
                        onClose={() => onChangeShowPrivacy(false)}
                        accept={formik.values.acceptPolicy}
                        onAccept={() => {
                            formik.setFieldValue('acceptPolicy', true);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Button
                        type="submit"
                        className="cancilleria-btn-primary"
                        disabled={disabledBtn}
                        onClick={formik.handleSubmit as any}
                    >
                        Registrar
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};
